import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareDistributeVerticalIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 11 17' {...props}>
    <path
      d='M10 1v3H7V1h3zm1-1H6v5h5V0zM10 6v3H7V6h3zm1-1H6v5h5V5zM10 13v3H7v-3h3zm1-1H6v5h5v-5zM0 4v1h2V4H0zm0-4v1h2V0H0zm0 6v1h2V6H0zm0 6v1h2v-1H0zm0-2v1h2v-1H0zm2 6H0v1h2v-1z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M10 1v3H7V1h3zm1-1H6v5h5V0zM10 7v3H7V7h3zm1-1H6v5h5V6zM10 13v3H7v-3h3zm1-1H6v5h5v-5zM0 4v1h2V4H0zm0-4v1h2V0H0zm0 6v1h2V6H0zm0 6v1h2v-1H0zm0-2v1h2v-1H0zm2 6H0v1h2v-1z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const DistributeVerticalIcon = memo(BareDistributeVerticalIcon);
